// Paused until the upsell admin is finished (GROW-19410). Restore the directive and effect below to load experiment content again.
// 'use client';
//
// import { useEffect } from 'react';
// import { fetchUpsellContent } from '../../slices/upsellContent';
// import { useAppDispatch } from '../../utils/redux';

// Loads the copy for every upsell trigger into the store and renders nothing. Belongs in the page layouts
// so that each surface reading the store shares one request: render it once per page, there is no dedupe.
export default function UpsellContentLoader() {
  // const dispatch = useAppDispatch();
  //
  // useEffect(() => {
  //   dispatch(fetchUpsellContent());
  // }, [dispatch]);

  return null;
}
